import React from "react"
import DataField from "./DataField"
import { titleCase } from "./utils"

function EnrichedCardholderData(props) {

    let enrichedData = props.enrichedData || {}

    if (!enrichedData.cardholder_document_number && !enrichedData.cardholder_name) {
        return (
            <div style={{display: "flex", flexGrow:"1"}}>
                <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                    Informação Indisponível
                </div>
            </div>
        )
    }

    return (
        <div className="internalCardContainer" style={{display: "flex", flexDirection: "column"}}>
            {enrichedData.cardholder_document_number ?
            <DataField
                title={"Documento"}
                label={enrichedData.cardholder_document_number}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
                display={"inline"}
            /> : null}
            {enrichedData.cardholder_name ?
            <DataField
                title={"Nome"}
                label={titleCase(enrichedData.cardholder_name, "-")}
                size={"normalMediumSize"}
                titleNoWrap={true}
                margin="5px"
                display={"inline"}
            /> : null}
        </div>
    )
}

export default EnrichedCardholderData
